import { sortMeals } from '../utils/meal';

export const getMealState = (store) => store.meal;
export const getMealIsLoading = (store) =>
    getMealState(store) ? getMealState(store).isLoading : false;
export const getAllMeals = (store) =>
    (getMealState(store) ? getMealState(store).meals : []).sort(sortMeals);
